module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/24.5c4e6f10.jpg";